<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </section>

        <section class="dp-right">
            <div class="kind-bar">
                <span class="kind-label">配置类型</span>
                <el-radio-group v-model="staffKind" size="small" @change="onStaffKindChange">
                    <el-radio-button label="approver">管理员审批</el-radio-button>
                    <el-radio-button label="cc">管理员抄送</el-radio-button>
                </el-radio-group>
            </div>

            <toolbar ref="toolbar" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

                        <el-table :data="users" v-loading="listLoading" style="width: 100%; margin-top: 20px;">
                <el-table-column prop="Name" label="姓名" min-width="">
                </el-table-column>
                <el-table-column label="关联教师" min-width="">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.TeacherId" type="primary" size="mini" effect="plain">{{ scope.row.TeacherName }}</el-tag>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="DepartmentName" label="所属部门" min-width="">
                </el-table-column>
                <el-table-column label="线别" width="100" align="center">
                    <template slot-scope="scope">
                        {{ honorLineText(scope.row.HonorLine) }}
                    </template>
                </el-table-column>
                <el-table-column label="所属校区">
                    <template slot-scope="scope">
                        <el-tag v-if="getCampusName(scope.row.CampusId) !== '-'" size="mini" type="primary" effect="plain">{{ getCampusName(scope.row.CampusId) }}</el-tag>
                        <el-tag v-else size="mini" type="info" effect="plain">未关联校区</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="Enabled" label="状态" width="" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.Enabled ? 'success' : 'danger'">
                            {{ scope.row.Enabled ? '启用' : '禁用' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="Remark" label="备注" min-width="" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="CreateTime" label="创建时间" width="" align="center">
                </el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="warning" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button size="mini" type="danger" @click="handleDel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination-container">
                <el-pagination layout="total,prev, pager, next" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" :current-page="page" :page-size="PageSize" :total="total"
                    style="float: right"></el-pagination>
            </div>

            <el-dialog :title="dialogTitle" :visible.sync="editFormVisible" width="40%" :close-on-click-modal="false">
                <el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">
                    <!-- 去除所属机构选择，直接关联页面统一选中的学校 ID -->
                    <el-form-item label="所属机构" v-if="editForm.Id > 0">
                        <el-input :value="editForm.DepartmentName || '—'" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="所属校区" prop="CampusId">
                        <el-select v-model="editForm.CampusId" placeholder="请选择校区" style="width: 100%" clearable
                            @change="handleCampusChange">
                            <el-option v-for="item in campusOptions" :key="item.Id" :label="item.Name" :value="item.Id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="教师" prop="TeacherId">
                        <div class="ps-pick-summary">
                            <span v-if="editForm.TeacherId">
                                已选 <strong>{{ selectedPersonLabel || ('教职工#' + editForm.TeacherId) }}</strong>
                            </span>
                            <span v-else class="muted-text">请选择一名教职工</span>
                            <el-button type="primary" size="mini" plain @click="openPersonPicker">选择教职工</el-button>
                            <el-button v-if="editForm.TeacherId" type="text" size="mini" @click="clearTeacherPick">清空</el-button>
                        </div>
                        <div class="form-tip">从通讯录选择，仅绑定一人</div>
                    </el-form-item>
                    <el-form-item label="线别" prop="HonorLine">
                        <el-select v-model="editForm.HonorLine" placeholder="线别范围" style="width: 100%">
                            <el-option label="全部" :value="0"></el-option>
                            <el-option label="德育线" :value="1"></el-option>
                            <el-option label="教学线" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="姓名" prop="Name">
                        <el-input v-model="editForm.Name" maxlength="50" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="启用状态">
                        <el-switch v-model="editForm.Enabled"></el-switch>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input type="textarea" v-model="editForm.Remark" :rows="3" maxlength="500"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="editFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="editSubmit" :loading="editLoading">确 定</el-button>
                </div>
            </el-dialog>

            <person-scope-picker-dialog
                :visible.sync="personPickerVisible"
                directory-scope="internal"
                :show-scope-tabs="false"
                :scope-department-id="editForm.DepartmentId || DepartmentId"
                :value="editForm.TeacherId"
                :label="selectedPersonLabel"
                @confirm="onPersonPicked"
            />
        </section>
    </section>
</template>

<script>
import { getHonorLineApproverListPage, addHonorLineApprover, editHonorLineApprover, removeHonorLineApprover, getHonorLineCcPersonListPage, addHonorLineCcPerson, editHonorLineCcPerson, removeHonorLineCcPerson } from '../../api/modules/moral-education';
import { getCampusList } from '../../api/modules/misc';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import PersonScopePickerDialog from '../../components/PersonScopePickerDialog';

/** 荣誉线：审批人与抄送人员共用一页，通过顶部类型切换接口。 */
export default {
    name: "HonorLineStaffConfig",
    components: { Toolbar, DepartmentPane, PersonScopePickerDialog },
    props: {
        /** 进入页面时的默认类型：approver 审批人，cc 抄送（兼容旧菜单各指向同一组件不同默认项） */
        initialKind: {
            type: String,
            default: "approver",
            validator: (v) => v === "approver" || v === "cc"
        }
    },
    data() {
        return {
            staffKind: "approver",
            filters: {
                campusId: null
            },
            campusOptions: [],
            searchList: [
                { label: '姓名', key: 'name' },
                {
                    label: '选择校区',
                    key: 'campusId',
                    type: 'select',
                    clearable: true,
                    options: [],
                },
            ],
            users: [],
            total: 0,
            page: 1,
            PageSize: 10,
            listLoading: false,
            buttonList: [],
            DepartmentId: 0,

            dialogTitle: '',
            editFormVisible: false,
            editLoading: false,
            personPickerVisible: false,
            selectedPersonLabel: '',
            editFormRules: {
                CampusId: [{ required: true, message: "请选择所属校区", trigger: "change" }],
                Name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
                TeacherId: [{ required: true, message: "请选择教师", trigger: "change" }],
            },
            editForm: {
                Id: 0,
                Name: '',
                DepartmentId: 0,
                DepartmentName: '',
                CampusId: null,
                TeacherId: null,
                HonorLine: 0,
                Enabled: true,
                Remark: '',
            }
        };
    },
    created() {
        this.staffKind = this.initialKind === "cc" ? "cc" : "approver";
    },
    methods: {
        roleTitle() {
            return this.staffKind === "approver" ? "校级审批人" : "抄送人员";
        },
        onStaffKindChange() {
            this.page = 1;
            if (this.editFormVisible) {
                this.editFormVisible = false;
            }
            this.getUsers();
        },
        treeNodeClick(data) {
            this.DepartmentId = data.value;
            this.filters.campusId = null;
            this.loadCampusOptions(this.DepartmentId);
            this.$nextTick(() => {
                if (this.$refs.toolbar && this.$refs.toolbar.searchObj) {
                    this.$refs.toolbar.searchObj.campusId = null;
                }
                this.handleQuery();
            });
        },
        handleQuery() {
            this.page = 1;
            this.getUsers();
        },
        getUsers() {
            let para = {
                page: this.page,
                intPageSize: this.PageSize,
                departmentId: this.DepartmentId,
                ...this.filters
            };
            if (para.campusId === null || para.campusId === undefined) {
                para.campusId = 0;
            }
            this.listLoading = true;
            const req = this.staffKind === "approver"
                ? getHonorLineApproverListPage(para)
                : getHonorLineCcPersonListPage(para);
            req.then((res) => {
                this.total = res.data.response.dataCount;
                this.users = res.data.response.data;
                this.listLoading = false;
            }).catch(() => {
                this.listLoading = false;
            });
        },
        handleSizeChange(val) {
            this.PageSize = val;
            this.getUsers();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getUsers();
        },
        callFunction(item) {
            if (typeof item.search == 'object') {
                this.filters = item.search;
            } else {
                this.filters = {
                    name: item.search
                };
            }
            this[item.Func].apply(this, item)
        },
        handleAdd() {
            if (!this.DepartmentId || this.DepartmentId === '0' || this.DepartmentId === 0) {
                this.$message.warning('请先在左侧选择具体的学校机构！');
                return;
            }
            this.dialogTitle = `新增荣誉采集${this.roleTitle()}`;
            this.editFormVisible = true;
            this.selectedPersonLabel = '';
            this.loadCampusOptions(this.DepartmentId);

            this.editForm = {
                Id: 0,
                Name: '',
                DepartmentId: this.DepartmentId,
                DepartmentName: '',
                CampusId: this.filters.campusId,
                TeacherId: null,
                HonorLine: 0,
                Enabled: true,
                Remark: '',
            };

            this.$nextTick(() => {
                if (this.$refs.editForm) {
                    this.$refs.editForm.clearValidate();
                }
            });
        },
        handleEdit(row) {
            this.dialogTitle = `编辑荣誉采集${this.roleTitle()}`;
            this.editFormVisible = true;
            const schoolId = row.DepartmentId || this.DepartmentId;
            this.loadCampusOptions(schoolId);
            this.editForm = Object.assign({}, row);
            this.editForm.DepartmentId = schoolId;
            this.selectedPersonLabel = row.TeacherName || row.Name || '';

            if (this.editForm.CampusId === 0 || this.editForm.CampusId === '0') {
                this.$set(this.editForm, 'CampusId', null);
            }

            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.$refs.editForm) {
                        this.$refs.editForm.clearValidate();
                    }
                }, 200);
            });
        },
        handleDel(row) {
            this.$confirm('确认删除该记录吗？', '提示', { type: 'warning' }).then(() => {
                this.listLoading = true;
                const req = this.staffKind === "approver"
                    ? removeHonorLineApprover({ id: row.Id })
                    : removeHonorLineCcPerson({ id: row.Id });
                req.then((res) => {
                    this.listLoading = false;
                    if (res.data.success) {
                        this.$message({ message: '删除成功', type: 'success' });
                        this.getUsers();
                    }
                });
            });
        },
        loadCampusOptions(deptId) {
            const schoolId = deptId || this.DepartmentId || 0;
            if (schoolId > 0) {
                getCampusList({ page: 1, intPageSize: 999, departmentId: schoolId }).then(res => {
                    if (res.data.success) {
                        this.campusOptions = res.data.response.data || [];
                        const campusSearch = this.searchList.find(e => e.key === 'campusId');
                        if (campusSearch) {
                            campusSearch.options = this.campusOptions.map(e => ({
                                label: e.Name,
                                value: e.Id
                            }));
                        }
                    }
                });
            } else {
                this.campusOptions = [];
                const campusSearch = this.searchList.find(e => e.key === 'campusId');
                if (campusSearch) campusSearch.options = [];
            }
        },
        editSubmit() {
            this.$refs.editForm.validate((valid) => {
                if (valid) {
                    this.editLoading = true;
                    let para = Object.assign({}, this.editForm);
                    if (!para.DepartmentId) {
                        para.DepartmentId = this.DepartmentId;
                    }

                    const apiCall = para.Id > 0
                        ? (this.staffKind === "approver" ? editHonorLineApprover : editHonorLineCcPerson)
                        : (this.staffKind === "approver" ? addHonorLineApprover : addHonorLineCcPerson);
                    apiCall(para).then((res) => {
                        if (res.data.success) {
                            this.$message({ message: '提交成功', type: 'success' });
                            this.editFormVisible = false;
                            this.getUsers();
                        } else {
                            this.$message.error(res.data.msg || '提交失败');
                        }
                        this.editLoading = false;
                    }).catch(() => {
                        this.editLoading = false;
                    });
                }
            });
        },
        /** 换校区时清空已选教师（权限范围变更）。创建于 2026-09-23 */
        handleCampusChange() {
            this.clearTeacherPick();
        },
        getCampusName(campusId) {
            if (!campusId || campusId === 0 || campusId === '0' || !this.campusOptions.length) return '-';
            const campus = this.campusOptions.find(c => c.Id === campusId);
            return campus ? campus.Name : '-';
        },
        /** 打开内部通讯录单选教职工。创建于 2026-09-23 */
        openPersonPicker() {
            const schoolId = this.editForm.DepartmentId || this.DepartmentId;
            if (!schoolId) {
                this.$message.warning('请先在左侧选择学校！');
                return;
            }
            this.personPickerVisible = true;
        },
        clearTeacherPick() {
            this.editForm.TeacherId = null;
            this.selectedPersonLabel = '';
            this.$nextTick(() => {
                if (this.$refs.editForm) this.$refs.editForm.validateField('TeacherId');
            });
        },
        onPersonPicked(person) {
            if (!person) return;
            this.editForm.TeacherId = person.id;
            this.selectedPersonLabel = person.name || '';
            if (person.name) this.editForm.Name = person.name;
            this.$nextTick(() => {
                if (this.$refs.editForm) {
                    this.$refs.editForm.validateField('TeacherId');
                    this.$refs.editForm.validateField('Name');
                }
            });
        },
        honorLineText(v) {
            if (v === 1) return '德育线';
            if (v === 2) return '教学线';
            return '全部';
        }
    },
    mounted() {
        let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
        this.buttonList = getButtonList(this.$route.path, routers);
        if (!this.buttonList.some(b => b.Func === 'handleQuery')) {
            this.buttonList.unshift({
                name: '查询',
                Func: 'handleQuery',
                id: 999
            });
        }
    }
};
</script>

<style scoped>
.kind-bar {
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
}

.kind-label {
    font-size: 14px;
    color: #606266;
    margin-right: 4px;
}

.pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
}

.ps-pick-summary {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    color: #475569;
    font-size: 13px;
}
.muted-text {
    color: #94a3b8;
}
.form-tip {
    color: #909399;
    font-size: 12px;
    line-height: 1.4;
    margin-top: 6px;
}

/* 窄屏响应式优化：防止 40% 的审批/抄送人员配置弹窗在窄屏/分栏下太挤 */
@media (max-width: 992px) {
    ::v-deep .el-dialog {
        width: 92% !important;
    }
    ::v-deep .el-dialog .el-form-item {
        display: flex;
        flex-direction: column;
        align-items: flex-start !important;
        margin-bottom: 16px;
    }
    ::v-deep .el-dialog .el-form-item__label {
        width: 100% !important;
        text-align: left !important;
        padding: 0 0 6px !important;
        line-height: 1.35 !important;
        font-weight: 600;
        color: #334155;
    }
    ::v-deep .el-dialog .el-form-item__content {
        margin-left: 0 !important;
        width: 100% !important;
    }
}
</style>
